module.exports = __webpack_public_path__ + "img/product_1_3.63e87bae.jpg";